import { useMemo } from 'react';

import { useStaffInRegion } from './useStaffInRegion';

/**
 * The crew picker's staff list, plus — in all-staff mode — the ids of the
 * staff who count as in-region. The server decides who is in-region (the
 * region, the regions above it and the regions below it), so the
 * "Outside region" tag reuses its region-scoped list rather than re-deriving
 * the rule here. `inRegionIds` is null in region mode, where every row matches.
 */
export function useCrewPickerStaff(regionId: string | null, allRegions: boolean) {
  const staff = useStaffInRegion(regionId, allRegions ? 'all' : 'region');
  const { data: regionStaff } = useStaffInRegion(regionId);
  const inRegionIds = useMemo(
    () => (allRegions && regionId ? new Set((regionStaff ?? []).map((s) => s.id)) : null),
    [allRegions, regionId, regionStaff],
  );
  return { ...staff, inRegionIds };
}
